module.exports = __webpack_public_path__ + "img/code.c9889487.png";